/* global wpVars */
import { select } from 'modules/dom';

const MESSAGE_SELECTOR = '.js-message';
const FORM_SELECTOR = '.js-sign-in-form';
const USERNAME_INPUT_SELECTOR = '.js-username';
const PASSWORD_INPUT_SELECTOR = '.js-password';
const DELAY = 10000; // 10s delay

export default el => {
  const messageEl = select(MESSAGE_SELECTOR, el);
  const formEl = select(FORM_SELECTOR, el);
  const userNameInputEl = select(USERNAME_INPUT_SELECTOR, el);
  const passwordInputEl = select(PASSWORD_INPUT_SELECTOR, el);

  let school = {};
  let defaultClass = {};
  // update message
  function updateMessage (message) {
    if (messageEl) {
      messageEl.innerHTML = message;
    }
  }

  function getUrlParams(url = window.location.href) {
    // Parse the URL
    const urlObj = new URL(url);

    // Get the search parameters from the URL
    const searchParams = new URLSearchParams(urlObj.search);

    // Create an object to hold the parameters
    const params = {};

    // Iterate over the search parameters and fill the object
    for (const [key, value] of searchParams) {
      params[key] = value;
    }

    // Return the parameters object
    return params;
  }

  function addParamsToRedirectUri(originalUrl, additionalParams) {
    // Parse the original URL
    const url = new URL(originalUrl);

    // Extract the redirect_uri from the parameters
    const redirectUri = url.searchParams.get('redirect_uri');

    // Decode the redirect_uri
    const decodedRedirectUri = decodeURIComponent(redirectUri);

    // Parse the redirect_uri
    const redirectUrl = new URL(decodedRedirectUri);

    // Add the additional parameters to the redirect_uri
    for (const [key, value] of Object.entries(additionalParams)) {
      redirectUrl.searchParams.append(key, value);
    }

    // Re-encode the redirect_uri
    const updatedRedirectUri = redirectUrl.toString();

    // Update the original URL with the new redirect_uri
    url.searchParams.set('redirect_uri', updatedRedirectUri);

    // Return the updated URL
    return url.toString();
  }

  // wait for 10s
  function nextRequest (res, data, callback, immediate = true) {
    if (res && data && data.length && res.hasOwnProperty('success') && !res.success) {
      updateMessage(data[0].message);
      return false;
    } else if (immediate) {
      callback(data);
    } else {
      let timeLeft = DELAY / 1000;
      updateMessage(`Preparing next request in ${timeLeft} seconds.`);
      var requestTimer = setInterval(function () {
        if (timeLeft <= 0) {
          clearInterval(requestTimer);
        } else {
          timeLeft -= 1;
          updateMessage(`Preparing next request in ${timeLeft} seconds.`);
        }
      }, 1000);
      setTimeout(() => {
        callback(data);
      }, DELAY);
    }
  }

  /**
   * Login users when we have enough data
   * @param data
   */
  function login (data) {
    if (data && data.hasOwnProperty('sso_url') && data.sso_url) {
      window.location.href = addParamsToRedirectUri(data.sso_url, getUrlParams());
    } else if (formEl && userNameInputEl && passwordInputEl) {
      // TODO: Remove this later because we do not need to login via form anymore
      userNameInputEl.value = data.email;
      passwordInputEl.value = data.password;
      if (window.location.search) {
        const newParam = window.location.search.replace(/&/g, '|');
        const newActionValue = 'https://readyassessments.econedlink.org/j_spring_security_check?landingPage=assessment/authoring/assessment/standard.htm&landingPageParam=action=view|' + newParam.substring(1) + '&tenant=cee';
        formEl.setAttribute('action', newActionValue);
      }
      formEl.submit();
    }
  }

  function logInGoogle (googleUser) {
    let url = googleUser.url;

    if (googleUser.is_returning) {
      url += '?accessToken=' + googleUser.token.access_token;
    } else {
      url += '?refreshToken=' + googleUser.token.refresh_token;
    }

    location.href = url;
  }

  function consumeLicense (userData) {
    jQuery.ajax({
      url : wpVars['ajaxUrl'],
      data : {
        action: 'oac_consume_user_license',
        school_name: school.schoolName
      },
      method : 'POST',
      success: function (res) {
        nextRequest(res, userData, login);
      },
      error: function (error) {
        updateMessage(`Error: ${error}`);
      }
    });
  }

  /**
   * Create new teacher
   */
  function createUser () {
    // updateMessage('Create teacher...');
    if (!defaultClass.classid) {
      const message = (Object.keys(defaultClass) || []).map(key => defaultClass[key].message).filter(v => v).join(' & ')
      if (message) {
        updateMessage(`Error: ${message}`); return;
      }
      updateMessage('Error: Failed to create default class!'); return;
    }
    if (!school.schoolId || !school.schoolName) {
      updateMessage('Error: Failed to create school!'); return;
    }
    jQuery.ajax({
      url : wpVars['ajaxUrl'],
      data : {
        action : 'oac_create_user',
        class_id: defaultClass.classid,
        school_id: school.schoolId,
        school_name: school.schoolName
      },
      method : 'POST',
      success: function (res) {
        nextRequest(res, res.data, consumeLicense);
      },
      error: function (error) {
        updateMessage(`Error: ${error}`);
      }
    });
  }

  /**
   * Create user license
   */
  function createUserLicense () {
    // updateMessage('Create teacher license...');
    jQuery.ajax({
      url : wpVars['ajaxUrl'],
      data : {
        action : 'oac_create_user_license',
        school_name: school.schoolName
      },
      method : 'POST',
      success: function (res) {
        nextRequest(res, res.data, createUser);
      },
      error: function (error) {
        updateMessage(`Error: ${error}`);
      }
    });
  }

  /**
   * Create a default class
   */
  function createDefaultClass (data) {
    /**
     * If school and school admin is already exists, use that school.
     * We do not want to re-assign school admin to new school
     */
    if (data && data.hasOwnProperty('school') && school.schoolId && data.school.schoolId !== school.schoolId) {
      school.schoolId = data.school.schoolId;
    }
    if (data && data.hasOwnProperty('classes')) {
      const testClass = (data.classes || []).find(c => c.classname === 'Test Class');
      if (testClass) {
        defaultClass = testClass
        nextRequest({}, {}, createUserLicense);
        return;
      }
    }
    // updateMessage('Create default class...');
    jQuery.ajax({
      url : wpVars['ajaxUrl'],
      data : {
        action : 'oac_create_default_class',
        school_name: school.schoolName,
        school_id: school.schoolId
      },
      method : 'POST',
      success: function (res) {
        /**
         * Have to lowercase object keys because MagicBox API return shit thing.
         * 2 requests, one return data has "classid" and another return "classId"
         */
        const responseData = Object.entries(res.data).reduce((a, [key, value]) => {
          a[key.toLowerCase()] = value;
          return a;
        }, {});
        defaultClass = responseData;
        nextRequest(res, responseData, createUserLicense);
      },
      error: function (error) {
        updateMessage(`Error: ${error}`);
      }
    });
  }

  /**
   * Create school admin
   */
  function createSchoolAmin () {
    // updateMessage('Create school admin...');
    jQuery.ajax({
      url : wpVars['ajaxUrl'],
      data : {
        action : 'oac_create_school_admin',
        school_name: school.schoolName,
        school_id: school.schoolId
      },
      method : 'POST',
      success: function (res) {
        nextRequest(res, res.data, createDefaultClass);
      },
      error: function (error) {
        updateMessage(`Error: ${error}`);
      }
    });
  }

  /**
   * Create school
   */
  function createSchool (user) {
    // updateMessage('Create school...');
    // 1. Create school
    jQuery.ajax({
      url : wpVars['ajaxUrl'],
      data : {
        action : 'oac_create_school'
      },
      method : 'POST',
      success: function (res) {
        school = res.data;
        nextRequest(res, res.data, createSchoolAmin);
      },
      error: function (error) {
        updateMessage(`Error: ${error}`);
      }
    });
  }

  /**
   * Check user if they have enough info (username + password) to sign in to Magicbox
   */
  function checkUser () {
    updateMessage('Logging in...');
    jQuery.ajax({
      url : wpVars['ajaxUrl'],
      data : {
        action : 'oac_check_user_exist'
      },
      method : 'POST',
      success: function (res) {
        const data = res.data;

        if (data && data.hasOwnProperty('sso_url') && data.sso_url) {
          nextRequest(res, data, login);
          return false;
        } else if (data && data.hasOwnProperty('is_google_connected') && data.is_google_connected) {
          nextRequest(res, data, logInGoogle);
          return false;
        } else {
          nextRequest(res, data, createSchool);
          return false;
        }
      },
      error: function (error) {
        updateMessage(`Error: ${error}`);
      }
    });
  }

  /**
   * 0. Checking user
   * 1. Create school
   * 2. Create school Admin
   * 3. Create class
   * 4. Create license
   * 5. Create teacher
   * 6. Consume license (Product assignment)
   * 7. Login
   */
  function init () {
    checkUser();
  }
  init();
};
